import React from 'react'
import PropTypes from 'prop-types'
import {
  BUTTON_TYPE,
  CONTAINER_STYLE,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
  TEXT_ALIGN,
} from '@helpers/constants'
import Container from '@components/Container'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Divider from '@components/Divider'
import SectionList from '@components/SectionList'
import Button from '@components/Button'

const NewSections = (props) => {
  const { heading, text, sections } = props

  return (
    <Container size={CONTAINER_STYLE.DESKTOP} paddingTop={false}>
      <div className='flex flex-col items-center'>
        {heading && (
          <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXLARGE}>
            {heading}
          </Heading>
        )}
        {text && (
          <div className='max-w-[600px]'>
            <Text align={TEXT_ALIGN.CENTER}>{text}</Text>
          </div>
        )}

        <Divider size={DIVIDER_SIZE.SMALL} />

        <Button
          type={BUTTON_TYPE.SECONDARY}
          to={'bibliotek/avsnitt'}
          icon={'ArrowRight'}
          iconClasses={'w-4 h-4'}
          iconRight
        >
          Visa alla avsnitt
        </Button>

        <Divider size={DIVIDER_SIZE.BASE} />

        <SectionList items={sections.slice(0, 3)} />
      </div>
    </Container>
  )
}

NewSections.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  sections: PropTypes.array,
}

export default NewSections
